import { z } from 'zod'

import { DateZod } from '../../common'
import { CostFormulaZod } from '../../configuration/configuration-automated-assignment-minutes-zod'
import { TeamTransportRequestAssigmentCostsZod } from '../costs'

export const AssigmentPlanZod = z.object({
  type: z.enum(['trf', 'solver']),
  formula: CostFormulaZod.nullish().default('points'),
  assignations: z.record(z.string()),
  cost: z.number().optional(),
  deleteAt: DateZod.optional(),
  costs: z.record(z.record(TeamTransportRequestAssigmentCostsZod)).optional(),
})
